export function getServiceMessage(): string | null {
  return process.env.NEXT_PUBLIC_SERVICE_MESSAGE ?? null;
}
